(() => {
  const itemTmpl = (key, val) =>
    `<a href="#agenda#${key}">
      <span>${val[0].header || "Custom Agenda " + key}</span>
    </a>`;

  const init = ($container, customAgendas) => {
    let shortcuts = {
      a: "#agenda#a",
      m: "#search#m",
      s: "#search#s",
    };
    $.each(customAgendas, (key) => shortcuts[key] = "#agenda#" + key);
    $(document).orgKeyboard(shortcuts);
    return $container;
  };

  $.fn.orgMenu = function(customAgendas) {
    return init(this.addClass("orgmenu").html(`
      <a href="#agenda#a"><span><u>A</u>genda</span></a>
      <a href="#search#m"><span><u>M</u>atch</span></a>
      <a href="#search#s"><span><u>S</u>earch</span></a>
      ${$.map(customAgendas, (val, key) => key !== "a" ? itemTmpl(key, val) : "").join("")}`
    ), customAgendas);
  };
})();
